<div cdkDropListGroup class="content-container">
  <div class="item-panel-container">
    <div class="container">
      <div class="top-items">
        <div class="heading">{{ panelTitle }}</div>
        @if(requiredWarning && !allRequired) {
          <mat-icon matTooltip="{{warningTooltip}}" class="warning-icon">info</mat-icon>
        }
      </div>

      <div class="filter-items">
        <form [formGroup]="form">
          <mat-form-field class="dept-dropdown">
            <mat-select (selectionChange)="onDepartmentChange($event)" name="department" placeholder="Departments"
              [disabled]="searchActive" formControlName="deptControl">
              @for (selection of departments; track selection) {
                <mat-option [value]="selection.value">{{selection.viewValue}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </form>
        <!--  TO BE USED AT A LATER DATE
        @if(unusedToggle) {
          <div>
            <p><mat-slide-toggle (change)="onToggleChange($event)">{{unusedToggleText}}</mat-slide-toggle></p>
          </div>
          } -->
        </div>
      </div>
      <div class="panel-body">
        @if(searchBar || searchBar && panelType === 2) {
          <div class="search-bar">
            <mat-form-field subscriptSizing="dynamic" class="item-search">
              <input matInput [(ngModel)]="searchText" />
            </mat-form-field>
            @if(!searchActive) {
              <button matSuffix mat-icon-button class="search-button" (click)="searchPanel(searchText)">
                <mat-icon>search</mat-icon>
              </button>
            } @else {
              <button matSuffix mat-icon-button class="search-button" (click)="clearSearch()">
                <mat-icon>clear</mat-icon>
              </button>
            }
          </div>
          <div class="item-list"
            [cdkDropListSortingDisabled]="true"
            cdkDropList
            [id]="'parentList'"
            [cdkDropListData]="itemList">
            @for (item of itemList; track item) {
              <div class="item-box"
                cdkDrag
                [cdkDragData]="item"
                [ngStyle]="{'background-color': checkTaskInUse(item.taskId) ? '#C4C4C4' : 'white'}">
                <div class="item-name-text"
                  #nameEl
                  style="max-width: 350px;"
                  [matTooltip]="isOverflowing(nameEl) ? item.taskName : ''"
                  matTooltipPosition="right"
                  [innerHTML]="getDisplayTaskName(item)">
                </div>
                <div class="item-icons">
                  @if(panelType === 1) {
                    <mat-icon class="star-icon">star</mat-icon>
                  }
                  <mat-icon>menu</mat-icon>
                </div>
              </div>
            }
          </div>
        } @else {
          <div class="empty-text-side">
            <span style="width: 187px; text-align:center;">{{this.panelTooltip}}</span>
          </div>
        }
      </div>
    </div>

    <div class="setup-container">
      @if (stationList.length > 0) {
        <div class="setup-window">
          @for (targetList of stationList; track targetList) {
            <div class="setup-list"
              >
              <div class="station-setup-section">
                <button class="station-button" (click)="editStation(targetList)">
                  {{targetList.name}}
                  <mat-icon>edit</mat-icon>
                </button>
                @if(!hasConfiguration) {
                  <button class="remove-button" (click)="deleteStation(targetList)" [disabled]="!checkEmptyStation(targetList)">
                    <mat-icon style="height: 35px; width: 35px; font-size: 35px;">close</mat-icon>
                  </button>
                }
              </div>
              @for (taskGroup of targetList.taskGroup; track taskGroup; let i = $index) {
                <div class="task-group-level"
                  cdkDropList
                  [cdkDropListData]="taskGroup.taskList"
                  (cdkDropListDropped)="drop($event)">
                  <div class="setup-area">
                    @for (task of taskGroup.taskList; track task) {
                      <div class="item-box-setup"  style="border-radius: 4px;"
                        cdkDrag
                        [cdkDragData]="task">
                        <div class="setup-item">
                          <div class="setup-list-name">
                            <mat-icon style="padding-right: 45px;">menu</mat-icon>
                            <div class="item-name-text" style="max-width: 650px;"
                              #nameEl
                              [matTooltip]="isOverflowing(nameEl) ? task.taskName : ''"
                              matTooltipPosition="right"
                            [innerHTML]="getDisplayTaskName(task)"></div>
                          </div>
                          @if(task.taskType === 'Required') {
                            <mat-icon class="star-icon">star</mat-icon>
                          }
                          <!-- WILL IMPLEMENT DURATION ON AOC TASK AT A LATER DATE
                          @if(task.taskType === 'AOC') {
                            <div class="duration-elements">
                              <button class="duration-button" (click)="openDurationDialog(task, stationList)">
                                <mat-icon class="duration-icon">more_time</mat-icon>
                              </button>
                              <span>{{formatTaskDate(task.durationStart, task.durationEnd)}}</span>
                            </div>
                            } -->
                          </div>
                          @if(panelType === 1 && task.taskType === 'Required' || panelType === 2 && (task.taskType === 'AOC' || task.taskType === 'Optional')) {
                            <button class="remove-button" (click)="deleteTask(targetList, task)">
                              <mat-icon style="height: 25px; width: 25px; font-size: 25px;">close</mat-icon>
                            </button>
                          }
                        </div>
                      }
                      @if (taskGroup.taskList.length === 0) {
                        <div class="setup-list-empty">
                          {{ this.itemConstants.emptyDropZoneText}}
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        } @else {
          <div class="empty-text-setup">
            <span style="width: 383px; text-align: center;">{{this.setupTooltip}}</span>
          </div>
        }
        @if(!hasConfiguration) {
          <div class="station-container">
            <button class="station-button" (click)="addStation()">
              {{this.itemConstants.addStationButtonText}}
              <mat-icon>add_circle</mat-icon>
            </button>
          </div>
        }
      </div>
    </div>